import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Box,
    Typography
} from "@mui/material";
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

export default function SubmissionDialog({ open, status="fild", onClose, onLogout, onRetry }) {
    const isSuccess = status === "success";

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                // منع الإغلاق عند النقر خارج النافذة إذا كانت العملية ناجحة
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            // ✅ السر هنا: نتحكم في شكل الـ Paper المكون للدايلوج
            PaperProps={{
                elevation: 0, // إزالة الظل العائم
                variant: "outlined", // استخدام نمط الإطار ليبدو كـ Section
                sx: {
                    borderRadius: 4,
                    p: 2,
                    minWidth: 320,
                    textAlign: "center",
                    borderColor: 'divider', // لون الإطار يتبع الثيم (نهاري/ليلي)
                    backgroundColor: 'background.paper',
                    boxShadow: 'none', // تأكيد إزالة أي ظل افتراضي
                }
            }}
            // (اختياري) إذا كنت تريد إخفاء الخلفية السوداء (Backdrop) لجعله يبدو كجزء من الصفحة
            // slotProps={{ backdrop: { sx: { backgroundColor: 'transparent' } } }}
        >
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                {isSuccess ? (
                    <CheckCircleOutlineRoundedIcon color="success" sx={{ fontSize: 60 }} />
                ) : (
                    <ErrorOutlineRoundedIcon color="error" sx={{ fontSize: 60 }} />
                )}
            </Box>

            <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.2rem', mt: 1 }}>
                {isSuccess ? "تم حفظ البيانات بنجاح" : "فشل في حفظ البيانات"}
            </DialogTitle>

            <DialogContent>
                {isSuccess ? (
                    <DialogContentText>
                        تم إرسال جميع التقييمات بنجاح. يمكنك الآن إنهاء الجلسة بأمان والخروج.
                    </DialogContentText>
                ) : (
                    <DialogContentText color="error.main">
                        حدث خطأ أثناء محاولة حفظ البيانات، ربما بسبب مشكلة في الاتصال بالإنترنت.
                        <br />
                        هل تود إعادة المحاولة أم الخروج؟
                        <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1, fontWeight: 'bold' }}>
                            ملاحظة: الخروج الآن سيؤدي إلى فقدان بيانات الجلسة الحالية وإلغاء التقييمات التي لم تُحفظ.
                        </Typography>
                    </DialogContentText>
                )}
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 1 }}>
                {isSuccess ? (
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onLogout}
                    >
                        خروج
                    </Button>
                ) : (
                    <>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={onLogout}
                        >
                            تسجيل الخروج (فقدان البيانات)
                        </Button>
                        <Button
                            variant="outlined"
                            color="warning"
                            onClick={onRetry}
                            autoFocus
                        >
                            إعادة المحاولة
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}